export const SEARCH_CRITERIA_FIND_ME = Object.freeze({
  PHONE: 'phoneNumber',
  EMAIL: 'email',
  LICENSE_NUMBER: 'licenseNumber'
});



// WEBPACK FOOTER //
// ./src/constants/findMe.js